import { ErrorImage } from '../../../ErrorImage'

export function ErrorGenericImage() {
  return <ErrorImage src="/images/generic-error.png" alt="Error-Generic" />
}
